import type { RoomMetadata } from 'api/types';
import { roomInfoStore } from 'state/store';
import { applyWaitingUsersFromServer } from 'features/AccessRequests/utils/waitingListRegistry';

/**
 * Подготавливает joinApprovalData из server metadata: не возвращаем в waitingUsers
 * id, которые уже обработаны на клиенте.
 */
export const mergeJoinApprovalFromServer = (metadataJSON: RoomMetadata): RoomMetadata => {
    const incomingJoin = metadataJSON.joinApprovalData;
    if (!incomingJoin) {
        return metadataJSON;
    }

    const filteredWaitingUsers = applyWaitingUsersFromServer(incomingJoin.waitingUsers);

    if (filteredWaitingUsers === incomingJoin.waitingUsers) {
        return metadataJSON;
    }

    return {
        ...metadataJSON,
        joinApprovalData: {
            ...incomingJoin,
            waitingUsers: filteredWaitingUsers,
        },
    };
};

export const optimisticallyRemoveWaitingUsers = (waitingListIds: string[], operation: 'APPROVE' | 'REJECT'): void => {
    const metadata = roomInfoStore.metadata;
    if (!metadata?.joinApprovalData) {
        return;
    }

    const waitingSet = new Set(waitingListIds);
    const currentJoinData = metadata.joinApprovalData;
    const movedUsers = (currentJoinData.waitingUsers || []).filter((u) => waitingSet.has(u.waitingListId));
    const nextWaitingUsers = (currentJoinData.waitingUsers || []).filter((u) => !waitingSet.has(u.waitingListId));

    roomInfoStore.setMetadata({
        ...metadata,
        joinApprovalData: {
            ...currentJoinData,
            waitingUsers: nextWaitingUsers,
            acceptedUsers:
                operation === 'APPROVE'
                    ? [...(currentJoinData.acceptedUsers || []), ...movedUsers]
                    : currentJoinData.acceptedUsers || [],
            rejectedUsers:
                operation === 'REJECT'
                    ? [...(currentJoinData.rejectedUsers || []), ...movedUsers]
                    : currentJoinData.rejectedUsers || [],
        },
    });
};
